/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-undef */
export default (
  category = { success: null, error: null, cart: [] },
  action
) => {
  switch (action.type) {
    case "GET_CATEGORIES_ALL":
      return { ...category, cart: action.payload };
    case "CREATE_CATEGORY":
      return { ...category, cart: [...category.cart, action.payload] };

    case "DELETE_CATEGORY":
      return {
        ...category,
        cart: category.cart.filter((data) => data._id !== action.payload),
      };
    case "UPDATE_CATEGORY":
      return { ...category, cart: [...category.cart, action.payload] };

    default:
      return category;
  }
};
